import { extendTheme } from "@chakra-ui/theme-utils";
import '@fontsource/roboto';
import '@fontsource/roboto-condensed';

const theme = extendTheme({
    styles: {
        global: {
            body: {
                color: "black"
            },
            h1: {
                color: "black"
            },
            h2: {
                color: "black"
            },
            h3: {
                color: "black"
            },
            h4: {
                color: "black"
            }
        }
    },
    fonts: {
        body: "'Roboto', sans-serif",
        heading: "'Roboto Condensed', sans-serif"
    },
    fontSizes: {
        xs: "12px",
        sm: "14px",
        md: "16px",
        lg: "18px",
        xl: "20px",
        "2xl": "21px",
        "3xl": "25px",
        "4xl": "30px",
        "5xl": "36px",
        "6xl": "64px",
    },
    colors: {
        black: "#2F2522",
        white: "#ffffff",
        gray: {
            50: "#F5F4F4", // offwhite
            400: "#D5D3D3", // gray-4
            500: "#ACA8A7", // gray-3
            700: "#827C7A", // gray-2
            900: "#59514E", // gray-1
        },
        primary: {
            1: "#D0A698",
            2: "#56423C",
            3: "#BDA69F"
        },
        secondary: {
            1: "#96B2D1",
            2: "#627E9A"
        }
    },
    breakpoints: {

    }
});

export default theme;